import { Component, inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { UseHttpImageSourcePipe } from './../../pipes/http-image-src.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'educare-confirmation-popup',
  templateUrl: './expand-image.component.html',
  styleUrl: './expand-image.component.scss',
  imports: [CdkScrollable, MatDialogContent, UseHttpImageSourcePipe, MatIcon, MatButtonModule, PdfViewerModule]
})
export class ExpandImageComponent implements OnInit {
  public readonly dialogRef = inject(MatDialogRef<ExpandImageComponent>);
  public readonly data = inject(MAT_DIALOG_DATA);

  @Input() isServer: boolean = true;
  isPdf: boolean = false;
  pdfUrl: string = '';

  ngOnInit(): void {
    if (this.data) {
      this.isServer = this.data.isServer ?? true;
      this.isPdf = this.data.isPdf ?? false;
      // Add custom panel class based on content type
      if (this.isPdf) {
        this.dialogRef.addPanelClass('pdf-preview-dialog');
      } else {
        this.dialogRef.addPanelClass('image-preview-dialog');
      }
      // Set PDF URL if provided
      if (this.isPdf && this.data.pdfUrl) {
        this.pdfUrl = this.data.pdfUrl;
      }
    }
  }
}
